var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryContainers32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Containers_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Containers_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-7",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Containers_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,29 L28,29 L28,27 L3,27 L3,29 Z M4,26 L27,26 L27,17 L4,17 L4,26 Z M28,17 L28,26 L28.5,26 C28.776,26 29,26.224 29,26.5 L29,29.5 C29,29.776 28.776,30 28.5,30 L2.5,30 C2.224,30 2,29.776 2,29.5 L2,26.5 C2,26.224 2.224,26 2.5,26 L3,26 L3,17 L2.5,17 C2.224,17 2,16.776 2,16.5 L2,13.5 C2,13.224 2.224,13 2.5,13 L2.57,13 L11.741,7.26 L12.272,8.107 L4.455,13 L20,13 L20,14 L3,14 L3,16 L28,16 L28,14 L21,14 L21,13 L26.545,13 L18.728,8.107 L19.259,7.26 L28.43,13 L28.5,13 C28.776,13 29,13.224 29,13.5 L29,16.5 C29,16.776 28.776,17 28.5,17 L28,17 Z M15.5,8 C16.603,8 17.5,7.103 17.5,6 L16.5,6 C16.5,6.551 16.052,7 15.5,7 C14.948,7 14.5,6.551 14.5,6 C14.5,5.449 14.948,5 15.5,5 C15.776,5 16,4.776 16,4.5 L16,2 L15,2 L15,4.063 C14.139,4.286 13.5,5.07 13.5,6 C13.5,7.103 14.397,8 15.5,8 L15.5,8 Z M6,24 L7,24 L7,19 L6,19 L6,24 Z M9,24 L10,24 L10,19 L9,19 L9,24 Z M12,24 L13,24 L13,19 L12,19 L12,24 Z M24,24 L25,24 L25,19 L24,19 L24,24 Z M21,24 L22,24 L22,19 L21,19 L21,24 Z M18,24 L19,24 L19,19 L18,19 L18,24 Z M15,24 L16,24 L16,19 L15,19 L15,24 Z",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryContainers32);
export default __webpack_public_path__ + "static/media/Arch-Category_Containers_32.b5ba966e4951004958e2eb6c3179cff2.svg";
export { ForwardRef as ReactComponent };